"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModelState = void 0;
/** Possible iModel states. */
var IModelState;
(function (IModelState) {
    /**
     * Not initialized iModel. iModel is not yet initialized and the server-side background initialization
     * process is still running. Initialization could take several minutes.
     */
    IModelState["NotInitialized"] = "notInitialized";
    /** Initialized iModel. It means that iModel initialization has completed and iModel is ready to use. */
    IModelState["Initialized"] = "initialized";
})(IModelState = exports.IModelState || (exports.IModelState = {}));
//# sourceMappingURL=IModelInterfaces.js.map